"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var index_1 = require("../IconLink/index");

exports.ContactModule = function (_a) {
  var className = _a.className,
      children = _a.children,
      id = _a.id,
      onClick = _a.onClick,
      phoneNumber = _a.phoneNumber,
      phoneText = _a.phoneText;
  var outerDivClassProps = {
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "footer-contact-module", className]),
    id: id
  };
  var href = phoneNumber ? "tel:" + phoneNumber : undefined;
  return React.createElement("div", __assign({}, outerDivClassProps), React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "footer-contact-module-phone"
  }, React.createElement(index_1.IconLink, {
    iconName: Icon_1.Icon.Names.communication___call,
    look: index_1.IconLink.Looks.LEFT,
    onClick: onClick,
    href: href
  }, phoneNumber), React.createElement("span", {
    className: CSSPrefix_1.lsgPre + "footer-contact-module-phone-message"
  }, phoneText)), React.createElement("ul", {
    className: CSSPrefix_1.lsgPre + "footer-contact-module-other-items"
  }, React.Children.map(children, function (child) {
    return React.createElement("li", null, child);
  })));
};

exports.ContactModule.displayName = "ContactModule";